<div>
    <div class="litmus-feed-list-view">
        <div class="litmus-feed-list-controls">
            <div class="ltms-description">
                {{desclaimer}}
            </div>
            <div class="litmus-right-controls">
                <!-- <app-score-search-bar [config]="searchBarConfig"
                (onSearch)="searchData($event)" *ngIf="isAccountLevelFeeds && feedView !== 'list'"></app-score-search-bar> -->
                <div class="litmus-grid-sort-wrapper" *ngIf="isAccountLevelFeeds && feedView == 'grid'">
                    <span class="litmus-grid-sort-label">Sort by</span>
                    <div class="litmus-grid-short-dropdown" #ltmsgridsortdd [class.dd-open]="isGridSortMenuOpen">
                        <button class="litmus-grid-short-dropdown-button" (click)="openGridSortMenu($event)">
                            <span>{{activeGridSort.label}} </span>
                            <div class="litmus-grid-short-dropdown-icon">
                                <img src="assets/images/menu-down-dark.svg" />
                            </div>
                        </button>
                        <ul class="litmus-grid-short-dropdown-menu">
                            <li *ngFor="let item of gridSortList"
                                [class.active]="activeGridSort.field == item.field && activeGridSort.order == item.order"
                                (click)="sortProjects($event,item)">{{item.label}}</li>
                        </ul>
                    </div>
                </div>
                <div class="litmus-toggle-button" *ngIf="isAccountLevelFeeds">
                    <button [class.active-view]="feedView == 'grid'" (click)="changeFeedView('grid')">
                        <img class="default-img" src="assets/images/view-grid.svg" />
                        <img class="active-img" src="assets/images/view-grid-active.svg" />
                    </button>
                    <button [class.active-view]="feedView == 'list'" (click)="changeFeedView('list')">
                        <img class="default-img" src="assets/images/view-list.svg" />
                        <img class="active-img" src="assets/images/view-list-active.svg">
                    </button>
                </div>
            </div>
        </div>
        <div class="litmus-feed-list-controls"
            *ngIf="!isAccountLevelFeeds ||  (isAccountLevelFeeds && feedView == 'list')">
            <div class="litmus-left-controls-wrapper" [class.wrapper-padding]="!isAccountLevelFeeds">
                <button class="scroll-btn left" *ngIf="showScrollButtons" (click)="scrollLeft()" aria-label="Scroll left">
                    <img src="assets/images/chevron-left.svg" />
                </button>
                <div class="litmus-left-controls" #leftControls>
                     <div class="litmus-feed-controls" [class.active]="!isReloadEnd" *ngIf="feedView == 'list'">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="refresh_feeds" [checked]="!isReloadEnd" />
                            <label for="refresh_feeds" (click)="refreshFeedList()">
                                <img class="default-img" src="assets/images/refresh.svg" />
                                <img class="active-img" src="assets/images/refresh-active.svg" />
                                Refresh
                            </label>
                        </div>
                    </div>
                    <div class="litmus-feed-controls" *ngIf="feedView == 'list'" [class.active]="filterSwitch.assign_to_me">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="assign_to_me" [checked]="(filterSwitch.assign_to_me)?'checked':''"
                                name="check" value="" />
                            <label for="assign_to_me" (click)="showFeedsby($event,'assign_to_me')">
                                <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                                <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                                Assigned to me
                            </label>
                        </div>
                    </div>
                    <div class="litmus-feed-controls" *ngIf="feedView == 'list'"
                        [class.active]="filterSwitch.followed_by_me">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="followed_by_me" [checked]="filterSwitch.followed_by_me" name="check"
                                value="" />
                            <label for="followed_by_me" (click)="showFeedsby($event,'followed_by_me')">
                                <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                                <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                                Followed by me
                            </label>
                        </div>
                    </div>
                    <div class="litmus-feed-controls" *ngIf="feedView == 'list'" [class.active]="filterSwitch.unread">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="show_unread" [checked]="filterSwitch.unread" />
                            <label for="show_unread" (click)="showFeedsby($event,'unread')">
                                <img class="default-img" src="assets/images/mail.svg" />
                                <img class="active-img" src="assets/images/mail_active.svg" />
                                Show unread
                            </label>
                        </div>
                    </div>
                    <div class="litmus-feed-controls" *ngIf="feedView == 'list' && !isAccountLevelFeeds"
                        [class.active]="filterSwitch.excluded_from_stats">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="excluded_from_stats" [checked]="filterSwitch.excluded_from_stats" />
                            <label for="excluded_from_stats" (click)="showFeedsby($event,'excluded_from_stats')">
                                <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                                <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                                Excluded from stats
                            </label>
                        </div>
                    </div>
                    <div class="litmus-feed-controls" *ngIf="feedView == 'list' && !isAccountLevelFeeds" [class.active]="filterSwitch.with_comment">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="with_comment" [checked]="filterSwitch.with_comment" />
                            <label for="with_comment" (click)="showFeedsby($event,'with_comment')">
                                <img class="default-img" src="assets/images/comment-outline.svg" />
                                <img class="active-img" src="assets/images/comment-fill.svg" />
                                With Comment
                            </label>
                        </div>
                    </div>
                    <div class="litmus-feed-controls" *ngIf="feedView == 'list' && !isAccountLevelFeeds" [class.active]="filterSwitch.without_comment">
                        <div class="litmus-feed-checkbox-control">
                            <input type="checkbox" id="without_comment" [checked]="filterSwitch.without_comment" />
                            <label for="without_comment" (click)="showFeedsby($event,'without_comment')">
                                <img class="default-img" src="assets/images/comment-off-outline.svg" />
                                <img class="active-img" src="assets/images/comment-off-fill.svg" />
                                Without Comment
                            </label>
                        </div>
                    </div>
                </div>
                <button class="scroll-btn right" *ngIf="showScrollButtons" (click)="scrollRight()" aria-label="Scroll right">
                    <img src="assets/images/chevron-right.svg" />
                </button>
            </div>
            <div class="litmus-right-controls">
                <div class="litmus-feed-filter" #litmusfeedsearch id="litmusfeedsearch"
                    *ngIf="!isAccountLevelFeeds && defaultSelectedField">
                    <div class="litmus-feed-filter-input" [class.active]="showFilterFields">
                        <img class="search-icon" src="assets/images/magnify.svg">
                        <input type="text" (keyup)="searchByTag($event)" [(ngModel)]="searchText"
                            (click)="toggleSearchList()" [placeholder]="feedSearch.placeholder" />
                        <button *ngIf="clearField.isEnabled" class="clear-button"
                            (click)="getFeedSforSelectedFields(clearField)">
                            <img class="clear-img" src="assets/images/close.svg">
                        </button>
                        <button (click)="toggleFilterFieldList()" class="field-dropdown-button"
                            [class.active]="showFilterFields">
                            <img src="assets/images/menu-down-dark.svg" />
                        </button>
                    </div>
                    <ul id="litmus-search-selector" *ngIf="isLoading" class="litmus-feed-filter-list">
                        <li class="loader">
                            <span class="circle-loader"></span> Just a moment.
                        </li>
                    </ul>
                    <ul id="litmus-search-list" *ngIf="showSearchList && !isLoading" class="litmus-feed-filter-list">
                        <li *ngFor="let item of searchResult.options" container="body" [disableTooltip]="item.isError"
                            placement="bottom" ngbTooltip="{{item.displayText || item.text}}"
                            tooltipClass="dropdown-menu-tooltip" [class.disabled-message]="item.isError"
                            (click)="getFeedSforSelectedFields(item)">
                            {{item.displayText || item.text}}
                        </li>
                    </ul>
                    <ul id="litmus-search-selector" *ngIf="showFilterFields" class="litmus-feed-filter-list">
                        <li *ngFor="let item of transactionTags" (click)="changeFilterField(item)"
                            [class.active]=" item.field_id == defaultSelectedField.field_id">
                            {{item.name}}
                        </li>
                    </ul>
                </div>
                <div class="litmus-button-group" *ngIf="!isAccountLevelFeeds && isReportDownloadAllowed">
                    <button (click)="openADRModal()">
                        <img src="assets/images/download-2.svg" />
                    </button>
                    <!-- <button>
                        <img src="assets/images/fullscreen-2.svg" />
                    </button> -->
                </div>
                <div class="litmus-feed-list-paging">
                    <button [disabled]="!pagingButtons.isFirst || !isDataLoaded" (click)="paginateFeedList('first')">
                        <img src="assets/images/chevron-double-left.svg" />
                    </button>
                    <button [disabled]="!pagingButtons.isPrevious || !isDataLoaded"
                        (click)="paginateFeedList('previous')">
                        <img src="assets/images/chevron-left.svg" />
                    </button>
                    <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}}
                        of {{pagingDetails.total}} </span>
                    <button [disabled]="!pagingButtons.isNext || !isDataLoaded" (click)="paginateFeedList('next')">
                        <img src="assets/images/chevron-right.svg" />
                    </button>
                    <button [disabled]="!pagingButtons.isLast || !isDataLoaded" (click)="paginateFeedList('last')">
                        <img src="assets/images/chevron-double-right.svg" />
                    </button>
                </div>

            </div>
        </div>
    </div>
    <div class="feed-list-view" *ngIf="isDataLoaded && feedView == 'list'">
        <app-ltms-data-table-v2 [columns]="columns" [data]="feeds" [errorCode]="'404'"
            (onSelect)="showFeedDetails($event)" [configs]="tableConfig" (onSort)="sortFeedList($event)"
            (onRowSelect)="showFeedDetails($event)" *ngIf="!showNoProjectsMessage"></app-ltms-data-table-v2>
    </div>
    <!-- No Projects Message -->
    <div class="no-projects-message" *ngIf="showNoProjectsMessage && isDataLoaded">
        {{"ACCOUNTS_INBOX_NOT_FOUND_MESSAGE"|translate}}
    </div>
    <div class="feed-grid-view" *ngIf="isDataLoaded && feedView == 'grid' && !showNoProjectsMessage">
        <div class="totoal-response-card">
            <div class="totoal-response-value">{{totalResponseCount|number}}</div>
            <div class="totoal-response-label">Total Responses (All Projects)</div>
        </div>
        <div class="feeds-card" *ngFor="let project of projects">
            <div class="feed-card-header">
                <div class="card-title" placement="bottom" ngbTooltip="{{project.name}}"
                    (click)="navigetToProject($event,project)" tooltipClass="custom-tooltip-background">
                    {{project.name}}</div>
                <!-- <img class="card-icon" src="assets/images/pin.svg" /> -->
                <div class="pin-wrapper">
                    <img class="card-icon" src="assets/images/pin.svg" />
                    <div class="tooltip-box">Coming soon!</div>
                </div>
            </div>
            <div class="feed-card-body">
                <div class="card-value">{{project.doc_count}}</div>
                <div class="card-label">Responses</div>
            </div>
            <div class="feed-card-footer">
                <div class="card-label">Last received on</div>
                <div class="card-value" *ngIf="project.last_response_received_at != 'NA'">
                    {{ project.last_response_received_at | date:"dd MMM ''yy HH:mm" }}
                </div>
                <div class="card-value" *ngIf="project.last_response_received_at == 'NA'">
                    {{ project.last_response_received_at }}
                </div>
            </div>
        </div>
    </div>

    <div class="feed-list-loader" *ngIf="!isDataLoaded">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>
<app-feed-detail-panel (onPageChange)="onPageChange($event)"></app-feed-detail-panel>
<litmus-response-downloader *ngIf="isADRMOdalOpen" [brandDetails]="brandDetails" [filters]="filters"
    [paginationDetail]="pagingDetails" (onClose)="closeADRModal()"></litmus-response-downloader>